import {
  IconAlertTriangle,
  IconBan,
  IconCheck,
  IconClock,
  IconEscalatorUp,
  IconHelpCircle,
  IconListNumbers,
} from "@tabler/icons-react";
import { displayCurrencyAmount } from "../../utils/display";
import type { ReceivablesFilterTileIcon, ReceivablesStripTile } from "./types";

function statusIcon(icon: ReceivablesFilterTileIcon) {
  if (icon === "list") return IconListNumbers;
  if (icon === "approved") return IconCheck;
  if (icon === "inProgress") return IconClock;
  if (icon === "unresolved") return IconBan;
  if (icon === "needsAttention") return IconAlertTriangle;
  if (icon === "escalated") return IconEscalatorUp;
  if (icon === "pendingApproval") return IconClock;
  return IconHelpCircle;
}

function statusIconColor(
  icon: ReceivablesFilterTileIcon,
  active: boolean,
): string {
  if (active) return "text-blue-700";
  if (icon === "approved") return "text-emerald-600";
  if (icon === "inProgress") return "text-amber-600";
  if (icon === "unresolved") return "text-slate-500";
  if (icon === "needsAttention") return "text-rose-600";
  if (icon === "noReply") return "text-violet-600";
  if (icon === "escalated") return "text-indigo-600";
  if (icon === "pendingApproval") return "text-amber-600";
  return "text-slate-600";
}

export function ReceivablesStatusStrip({
  tiles,
  currency,
  isActive,
  onTileClick,
}: {
  tiles: ReceivablesStripTile[];
  currency: string;
  isActive: (tile: ReceivablesStripTile) => boolean;
  onTileClick: (tile: ReceivablesStripTile) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2 overflow-x-auto border-b border-slate-200 p-3">
      {tiles.map((tile) => {
        const active = isActive(tile);
        const Icon = statusIcon(tile.icon);
        const iconColorClass = statusIconColor(tile.icon, active);
        return (
          <button
            type="button"
            key={`${tile.filterGroup}:${tile.key}`}
            onClick={() => onTileClick(tile)}
            aria-pressed={active}
            className={`flex w-fit cursor-pointer items-center rounded-lg border px-3 py-2 text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 ${
              active
                ? "border-blue-400 bg-blue-50 text-blue-900"
                : "border-slate-200 bg-white text-slate-800 hover:bg-slate-50"
            }`}
          >
            <Icon size={20} className={`mr-2 ${iconColorClass}`} />
            <div className="items-center gap-1.5">
              <p className="text-xs font-semibold">{`${tile.label} (${tile.count})`}</p>
              <p className="mt-0.5 text-sm font-semibold">
                {displayCurrencyAmount(tile.amount, currency)}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
